import React from 'react';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  onClick, 
  disabled = false,
  fullWidth = false,
  icon = null,
 ...props 
}) => {
  const variants = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    danger: 'btn-danger',
    outline: 'btn-outline',
    ghost: 'btn-ghost',
  };

  const sizes = {
    sm: 'btn-sm',
    md: 'btn-md',
    lg: 'btn-lg',
  };

  return (
    <>
      <style>{`
       .btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          border: none;
          border-radius: 10px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
          font-family: 'Outfit', sans-serif;
        }
       .btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
       .btn-primary {
          background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%);
          color: #FFF;
          box-shadow: 0 4px 15px rgba(59, 130, 246, 0.3);
        }
       .btn-primary:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(59, 130, 246, 0.4);
        }
       .btn-secondary {
          background: #F1F5F9;
          color: #475569;
        }
       .btn-secondary:hover:not(:disabled) {
          background: #E2E8F0;
        }
       .btn-danger {
          background: #EF4444;
          color: #FFF;
          box-shadow: 0 4px 15px rgba(239, 68, 0.3);
        }
       .btn-danger:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(239, 68, 68, 0.4);
        }
       .btn-outline {
          background: transparent;
          border: 2px solid #3B82F6;
          color: #3B82F6;
        }
       .btn-outline:hover:not(:disabled) {
          background: #3B82F6;
          color: #FFF;
        }
       .btn-ghost {
          background: transparent;
          color: #64748B;
        }
       .btn-ghost:hover:not(:disabled) {
          background: #F1F5F9;
        }
       .btn-sm { padding: 8px 16px; font-size: 13px; }
       .btn-md { padding: 12px 24px; font-size: 15px; }
       .btn-lg { padding: 14px 32px; font-size: 16px; }
       .btn-full { width: 100%; }
       .btn-icon { font-size: 18px; }
      `}</style>
      <button 
        className={`btn ${variants[variant]} ${sizes[size]} ${fullWidth? 'btn-full' : ''}`}
        onClick={onClick}
        disabled={disabled}
        {...props}
      >
        {icon && <span className="btn-icon">{icon}</span>}
        {children}
      </button>
    </>
  );
};

export default Button;